import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { InputNumber, Slider } from "antd";
import { Grip, Trash2 } from "lucide-react";
import {
  SPACER_DEFAULT_SIZE,
  SPACER_MAX,
  SPACER_MIN,
} from "../../../optimizeResume/editor/config";

// Compact card. Does not use SectionCardShell because:
//   - Spacer has no content body that needs collapsing
//   - The "regenerate with AI" affordance doesn't apply to whitespace
// Drag-and-drop and delete are implemented inline so the card can stay tiny.
export default function Spacer({ id, data, onChange, onDelete }) {
  const size = Number.isFinite(data?.size) ? data.size : SPACER_DEFAULT_SIZE;

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };

  const updateSize = (v) => {
    const next = Math.max(SPACER_MIN, Math.min(SPACER_MAX, Math.round(v ?? 0)));
    onChange({ size: next });
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="border rounded-xl px-5 py-4 bg-white shadow-basic mb-3"
    >
      <div className="flex items-center gap-3">
        <span
          {...attributes}
          {...listeners}
          className="cursor-grab text-gray-400 hover:text-gray-600 touch-none"
          aria-label="Drag spacer"
        >
          <Grip size={16} />
        </span>
        <div className="flex flex-col">
          <span className="text-[.92rem] font-semibold text-[#344054]">
            Spacer
          </span>
          <span className="text-[.85rem] text-[#667085]">
            vertical gap in the PDF
          </span>
        </div>

        <div className="ml-auto flex items-center gap-3">
          <Slider
            min={SPACER_MIN}
            max={SPACER_MAX}
            value={size}
            onChange={updateSize}
            style={{ width: 160 }}
          />
          <InputNumber
            size="small"
            min={SPACER_MIN}
            max={SPACER_MAX}
            value={size}
            onChange={updateSize}
            addonAfter="pt"
            style={{ width: 92 }}
          />
          <Trash2
            size={16}
            className="cursor-pointer text-gray-500 hover:text-red-600"
            onClick={() => onDelete(id)}
            aria-label="Delete spacer"
          />
        </div>
      </div>

      {/* Visual preview — the faint band on screen matches the height that
          will appear in the PDF (scaled 1pt → ~1.33px in the browser). */}
      {/* <div
        aria-hidden
        className="mt-2 rounded bg-[#FFFAEB] border border-dashed border-[#FEC84B]"
        style={{ height: Math.max(2, size * 1.333) }}
      /> */}
    </div>
  );
}
